function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon-logout");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Icon-logout",
  transform: "translate(-1.000000, -1.000000)"
}, React.createElement("g", {
  id: "noun_off_2191010-copy",
  opacity: 0.402878534,
  transform: "translate(7.500000, 7.500000) scale(-1, 1) translate(-7.500000, -7.500000) translate(1.000000, 1.000000)",
  fill: "#000000"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(0.433333, 0.000000)"
}, React.createElement("path", {
  d: "M6.7356147,0.595070423 L6.7356147,6.5915493 C6.7356147,7.36971831 5.39771863,7.36971831 5.39771863,6.5915493 L5.39771863,0.595070423 C5.39771863,-0.183098592 6.7356147,-0.183098592 6.7356147,0.595070423 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M10.7493029,7.04929577 C10.7493029,5.08098592 9.59594423,3.47887324 7.84283904,2.74647887 C7.15082383,2.47183099 7.6121673,1.19014085 8.35031686,1.51056338 C10.6108999,2.47183099 12.087199,4.53169014 12.087199,7.04929577 C12.087199,10.3450704 9.41140684,13 6.04359949,13 C2.72192649,13 -3.46944695e-17,10.2992958 0.0461343473,7.00352113 C0.0461343473,4.48591549 1.56856781,2.42605634 3.78301648,1.51056338 C4.56730038,1.19014085 5.02864385,2.47183099 4.2904943,2.74647887 C2.58352345,3.47887324 1.38403042,5.08098592 1.38403042,7.04929577 C1.38403042,9.61267606 3.50621039,11.6725352 6.08973384,11.6725352 C8.62712294,11.6725352 10.7493029,9.61267606 10.7493029,7.04929577 Z",
  id: "Path"
}))), React.createElement("rect", {
  id: "Rectangle-Copy-34",
  fill: "#D8D8D8",
  opacity: 0,
  x: 0,
  y: 0,
  width: 14,
  height: 14
})));

const SvgHeaderLogout = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgHeaderLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/header-logout.b65f540c.svg";
export { ForwardRef as ReactComponent };